import { TiptapStickerButton } from './TiptapStickerButton'
import { withTiptapStickerButton } from './withTiptapStickerButton'

const ConnectedTiptapStickerButton =
  withTiptapStickerButton(TiptapStickerButton)

export { ConnectedTiptapStickerButton as TiptapStickerButton }
